import { useNavigate } from 'react-router-dom';
import { _deleteMyProfile } from '../../data/users';
import { toggleModal } from '../../utils/uiUtils';
import { useAuthStore } from '../../stores/useAuthStore';
import { signOut } from 'firebase/auth';
import { auth } from '../../utils/firebase.js';

function DeleteMyData() {
    const navigate = useNavigate();

    const deleteMyData = async () => {
        document.getElementById("closeButton").classList.add("is-hidden");
        document.getElementById("deleteProfileButton").classList.add("is-loading");
        var response = await _deleteMyProfile();
        if (response) {
            await signOut(auth);
            useAuthStore.getState().logout();
            navigate('/');
        }
    }

    return (
        <>
            <div className="is-size-5 has-text-weight-bold is-underlined mt-5">
                Delete your personal profile information
            </div>
            <div className="has-text-weight-bold has-text-danger">
                ! ! !    Caution ! ! !
            </div>
            <div className="has-text-weight-bold has-text-danger">
                This cannot be undone.
                <div className="buttons">
                    <button
                        className="button has-background-danger-40 has-text-white"
                        onClick={() => { toggleModal('modal-deleteMyData') }}>
                        Delete Account
                    </button>
                </div>
            </div>

            <div id="modal-deleteMyData" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Delete your personal profile information</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-deleteMyData') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="is-size-6">
                            <div className="is-size-5 mb-2 has-text-weight-bold">This cannot be undone!</div>
                            <div className="mb-0">If you have not, consider requesting your data first so you understand what is stored and decide if you wish it deleted</div>
                            <div className="content">
                                <div className="mb-0">Clicking proceed will:</div>
                                <ul className="mt-0">
                                    <li>Log you out</li>
                                    <li>Delete your authentication information</li>
                                    <li>Delete your user data </li>
                                    <li>Any campaigns you started and shared with others will be removed, and they will no longer have access</li>
                                    <li>If you rejoin later, you will have a new account. No previous history will be linked back to you</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                    <footer className="modal-card-foot is-flex is-justify-content-space-between">
                        <button className="button has-background-danger-40 has-text-white mr-5" id="deleteProfileButton" aria-label="close" onClick={() => { deleteMyData() }}>Proceed</button>
                        <button className="button is-primary mr-5" aria-label="close" id="closeButton" onClick={() => { toggleModal('modal-deleteMyData') }}>Close</button>
                    </footer>
                </div>
            </div>

        </>
    )
}

export default DeleteMyData;